// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  pageWrapper: {
    width: 1200,
    margin: '0 auto',
  },
  headerSection: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    margin: theme.spacing(4, 0, 2, 0),
  },
  headerText: {
    fontWeight: 600,
    fontSize: '18px',
  },
  backButton: {
    marginRight: theme.spacing(2),
    cursor: 'pointer',
  },
  divider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
});

export default styles;
